import { useEffect } from 'react'
import { Modal, Button } from 'antd'
import classNames from 'classnames'
import ActionBtn from '@/components/TableWidgets/ActionBtn'
import Action from '@/components/Action'
import styles from './index.less'
import useMain from './hooks/useMain'

const ActionButton = Action(Button)

export default props => {
    const store = useMain(props)

    useEffect(() => {
        store.init()
    }, [])

    const {
        dataSource,
        inputRef,
        countdown,
        sendCount,
        sendCode,
        codes,
        activeCodeIndex,
        isCodesValid,
        submit,
        keyupHandler,
        setIsFocused
    } = store

    const renderBtn = () => {
        if (countdown <= 0) {
            if (sendCount) {
                return <ActionBtn onClick={sendCode}>重新获取验证码</ActionBtn>
            }

            return <ActionBtn onClick={sendCode}>获取验证码</ActionBtn>
        }

        return (
            <span>
                <span className={styles.sCount}>{countdown}s</span>后重新获取
            </span>
        )
    }

    return (
        <Modal
            title="授权验证"
            width={480}
            keyboard={false}
            {...props}
            footer={
                <>
                    <ActionButton onClick={props.onCancel}>取消</ActionButton>
                    <ActionButton type="primary" disabled={!isCodesValid} onClick={submit}>
                        确定
                    </ActionButton>
                </>
            }
        >
            <div className={styles.content}>
                <div className={styles.desc}>{dataSource?.message}</div>
                <div className={styles.numBox}>
                    {codes.map((digit, index) => {
                        const isActive = activeCodeIndex === index

                        return (
                            <div
                                key={index}
                                className={classNames(styles.num, {
                                    [styles.isActive]: isActive
                                })}
                            >
                                {digit}
                                {isActive ? <div className={styles.activeLine} /> : null}
                            </div>
                        )
                    })}
                    <input
                        ref={inputRef}
                        className={styles.input}
                        type="number"
                        onKeyUp={keyupHandler}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                    />
                </div>
                <div className={styles.btnWrap}>{renderBtn()}</div>
            </div>
        </Modal>
    )
}
